define("static/js/base-conf",function(n,e){var i=2;e.version=i});